import Loadable from "react-loadable";
import PropTypes from "prop-types";
import LazyLoadingBar from "./LazyLoadingBar";

const LazyRangePicker =  Loadable({
    loader: () => import('./RangePicker'),
    loading: LazyLoadingBar,
});

LazyRangePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    config: PropTypes.any,
    value: PropTypes.array.isRequired
};

export default LazyRangePicker